<template>
    <div>
        <dates
            :read_only="read_only"
        />

        <price
            :deal="property.deal"
            :read_only="read_only"
        />

        <fees-paid
            :read_only="read_only"
        />

        <our-side
            :read_only="read_only"
        />
    </div>
</template>

<script>
import Dates from './intro/dates.vue';
import Price from './intro/price.vue';
import FeesPaid from './intro/fees-paid.vue';
import OurSide from './intro/our-side.vue';

export default {
    components: {
        Dates,
        Price,
        FeesPaid,
        OurSide,
    },

    props: {
        property: { default: () => ({}) },
        read_only: { default: false },
    },
}
</script>
